import { STTextTabAlignType } from '@tencent/slide-sdk-model';

// 制表位对齐方式 - sdk对上层类型映射
export const TEXT_TAB_ALIGN_TYPE_MAP = new Map([
    [STTextTabAlignType?.l, 'left'],
    [STTextTabAlignType?.r, 'right'],
    [STTextTabAlignType?.ctr, 'center'],
    [STTextTabAlignType?.dec, 'decimal'],
]);
